import { useContext } from 'react';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import { CompanyHotelsContext } from '@app/site/secured/rateshopper/rates/provider/CompanyHotelsProvider';

export const useSelectedCompanyHotel = (): {
	companyHotel: CompanyHotel,
} => {
	const { selectedCompanyHotel } = useContext(CompanyHotelsContext);

	const selected = selectedCompanyHotel!;

	return {
		companyHotel: selected,
	};
};